import { reducers } from '@wix/da-shared-react/pkg/redux/shared';
import profileOwner from './profileOwner';
import sections from './sections';
import gallectionSection from './gallectionSection';
import folders from './folders';
import layout from './layout';
import modules from './modules';
import statsSection from './statsSection';

const DEFAULT_ENVIRONMENT = {};

const rootReducers = {
  ...reducers,
  profileOwner,
  sections,
  gallectionSection,
  environment: state => state || DEFAULT_ENVIRONMENT,
  folders,
  layout,
  modules,
  statsSection,
};

export default rootReducers;
